App.controller('apptDetailCtrl', ($controller, $scope, $api, $rootScope, $filter, responseHelper, Appointment, Perm, ngDialog, datesInTimezone) => {
  $controller('apptCommonCtrl', {
    $scope: $scope
  })

  $scope.appt = $scope.ngDialogData.appt
  $scope.now = moment().toISOString()
  $scope.appt_is_past = $scope.appt.start_time < $scope.now
  $scope.buttonDisabled = false
  $scope.payment_errors = []
  $scope.setMyMinutes()

  // times in timezone is required for the calendar
  $scope.appt.start_time_with_tz = datesInTimezone.convertFromUtcToLocalTimezone($scope.appt.start_time, true)
  $scope.appt.end_time_with_tz = datesInTimezone.convertFromUtcToLocalTimezone($scope.appt.end_time, true)
  $scope.isEnliveEnabled = false

  if($scope.appt.status == 'unpaid' || $scope.appt.status == 'checked-in'){
    $scope.tab_index = 2
  } else {
    $scope.tab_index = 0
  }

  $scope.apptUpdate = (appt, check_long_appts = true) => {
    additionalRequestParams = {
      patient_missed: appt.patient_missed,
      checkin_at: appt.checkin_at,
      confirmed: appt.confirmed,
      checked_out: appt.checked_out,
      cancelled: appt.cancelled,
      appointment_type_id: appt.appointment_type_id,
      status: appt.status
    }
    apptUpdateAction(appt, additionalRequestParams, check_long_appts)
  }

  $scope.apptUnavailableUpdate = (appt) => {
    additionalRequestParams = {

    }
    apptUpdateAction(appt, additionalRequestParams)
  }

  apptUpdateAction = (appt, additionalRequestParams, check_long_appts = true) => {
    callback = () => {
      appt.appt = _.merge({ start_time: appt.start_time,
                            end_time: appt.end_time,
                            online_booking_form_response: appt.online_booking_form_response
                          }, additionalRequestParams)
      if (appt.status === 'paid') {
        appt.appt.paid = true
      }
      appt.$save(['appt'])
      apptSaveCallback(appt, true)
    }
    if (check_long_appts) {
      $scope.saveWithLongRunningCheck(appt, callback)
    } else {
      callback()
    }
  }

  apptSaveCallback = (appt, closeDialog) => {
    appt.$then((resp) => {
      if (responseHelper.redirectOrToastOnResp(appt)) {
        data = resp.$response.data.data
        if (!data) { return }
        appt = data.appt
        delids = data.delids
        if(delids && delids.length > 0){
          $rootScope.$broadcast('cancelEvents', delids)
        }
        if(appt && appt.confirmed){
          $rootScope.$broadcast('apptConfirmed', appt)
        }
        if (appt) {
          $rootScope.$broadcast('replaceEvents', [appt])
        }
        if (closeDialog === true) {
          $scope.closeThisDialog()
        }
      }
    })
  }

  show_checkin = () => {
    if ($scope.appt.hidden_checkin_at) {
      $scope.appt.checkin_at = $scope.appt.hidden_checkin_at
      $scope.appt.hidden_checkin_at = null
    } else {
      $scope.appt.checkin_at = moment().toISOString()
    }
  }

  hide_checkin = () => {
    if (!$scope.appt.hidden_checkin_at) {
      $scope.appt.hidden_checkin_at = $scope.appt.checkin_at
      $scope.appt.checkin_at = ''
    }
  }

  $scope.setApptStatus = (status, appt) => {
    savePrevStatus()
    $scope.appt.status = status
    if (status === 'checked-in') {
      $scope.appt.cancelled = false
      $scope.appt.patient_missed = false
      $scope.appt.checkin_at = new Date()
      $scope.appt.checked_out = false
    } else if (status === 'unconfirmed') {
      $scope.appt.confirmed = false
      $scope.appt.checkin_at = ''
      $scope.appt.patient_missed = false
      $scope.appt.checked_out = false
      hide_checkin()
    } else if (status === 'confirmed') {
      $scope.appt.confirmed = true
      $scope.appt.checkin_at = ''
      $scope.appt.patient_missed = false
      $scope.appt.checked_out = false
    } else if (status === 'completed') {
      $scope.appt.cancelled = false
      $scope.appt.patient_missed = false
      $scope.appt.checked_out = true
      hide_checkin()
    } else if (status === 'cancelled') {
      $scope.appt.cancelled = true
      $scope.appt.patient_missed = false
      $scope.appt.checkin_at = ''
      $scope.appt.checked_out = false
      hide_checkin()
    } else if (status === 'no-show') {
      $scope.appt.cancelled = false
      $scope.appt.patient_missed = true
      $scope.appt.checkin_at = ''
      $scope.appt.checked_out = false
      hide_checkin()
    }
  }

  savePrevStatus = () => {
    if ($scope.appt.status === 'upcoming') {
      $scope.appt.hidden_status = $scope.appt.status
    }
  }

  $scope.apptUnavailableCancel = (appt) => {
    apptCancelAction(appt, "this unavailable slot")
  }

  $scope.apptCancel = (appt) => {
    apptCancelAction(appt, "this appointment request")
  }

  apptCancelAction = (appt, cancel_text) => {
    withPopupCallback = () => {
      if(typeof($scope.closeThisDialog) == 'function'){
        $scope.closeThisDialog()
      }
    }
    withoutPopupCallback = () => {
      dialog = ngDialog.open({
        template: '/app/views/modal/confirm.html',
        data: {
          text: "Are you sure you want to cancel " + cancel_text + "?"
        },
        controller: 'confirmCtrl',
        className: 'ne__modal'
      })
      dialog.closePromise.then(d => {
        if(d.value === true){
          appt.$destroy().$then((data) => {
            if(appt.unavailable){
              $rootScope.$broadcast('deleteEvents', [appt.id])
            } else {
              $rootScope.$broadcast('cancelEvents', [appt.id])
            }
            if (typeof $scope.closeThisDialog == 'function') {
              $scope.closeThisDialog()
            }
          })
        }
      })
    }
    if(appt.unavailable){
      withoutPopupCallback()
    } else {
      $rootScope.activityProcessed(appt.uuid, withPopupCallback, withoutPopupCallback)
    }
  }

  Perm.perm_promise.then( () => {
    $scope.isEnliveEnabled = $rootScope.location.enlive_enabled
    $scope.canCreateFormRequest = !($scope.appt.patient.foreign_id && $scope.appt.patient.foreign_id.endsWith('_rp'))
    $scope.institution = Perm.institution
    $scope.confirmed_status = $scope.institution.config.confirmed_status  == 'true' || $scope.institution.config.confirmed_status === true ? true : false

    if($scope.appt.unavailable){
      $scope.dropdownNameStart = 'dropdownStart2'
      $scope.dropdownNameEnd = 'dropdownEnd2'
    } else {
      $scope.dropdownNameStart = 'dropdownStart1'
      $scope.dropdownNameEnd = 'dropdownEnd1'
    }

    return $scope.loaddocs()
  }).then(() => {
    watchProviderChange()

    if(angular.isUndefined($scope.appt.provider_id) && $scope.providers.length > 0){
      $scope.appt.provider_id = $scope.providers[0].id
    }
  })

  $scope.reminder_text = (reminder_time) => {
    var str=''
    if(Date.parse(reminder_time) < Date.now()) {
      str = "A reminder text was sent at "
    } else {
      str = "A reminder text will be sent at "
    }
    return str + $filter('date')(reminder_time, 'M/d/yy')
  }

  getFutureReminderTime = () => {
    var ftime
    _.each($scope.appt.reminder_times, (rem_time) => {
      if(Date.parse(rem_time)>=Date.now()) {
        ftime = rem_time
      }
    })
    $scope.future_reminder_time = ftime
  }

  if (!$scope.appt.patient_confirmed) {
    getFutureReminderTime()
  }

  // React Web Component requires a function declared on window/global scope.
  // https://github.com/bitovi/react-to-web-component/blob/main/docs/api.md#function-props
  window.closeFormRequestDialog = () => {
    let newFormRequestModal = document.querySelector('nh-forms-request-modal')
    if (newFormRequestModal) {
      newFormRequestModal.setAttribute('opened', 'false')
    }
  }

  // Forms
  $scope.openFormRequestDialog = () => {
    let newFormRequestModal = document.querySelector('nh-forms-request-modal')
    if (newFormRequestModal) {
      newFormRequestModal.setAttribute('patientid', $scope.appt.patient_id)
      newFormRequestModal.setAttribute('opened', 'true')
      newFormRequestModal.setAttribute('onclose', 'closeFormRequestDialog')
    }
  }
})
